import {
  SurfaceRefFragment,
  SurfacesDocument,
  SurfacesQuery,
  useOnSurfaceCreatedSubscription,
  useOnSurfaceDeletedSubscription,
  useOnSurfaceUpdatedSubscription,
  withNewStandardListHook,
} from '@spotify/confidence-graphql';

const useSurfacesImpl = withNewStandardListHook<
  SurfacesQuery,
  SurfaceRefFragment,
  'surfaces'
>(SurfacesDocument, 'surfaces', {
  typename: 'WorkflowV1ListSurfacesResponse',
  fragmentName: 'SurfaceRef',
});

export const useSurfaces: typeof useSurfacesImpl = options => {
  useOnSurfaceCreatedSubscription({
    onData: ({ client }) => {
      client.refetchQueries({
        include: [SurfacesDocument],
      });
    },
  });

  useOnSurfaceUpdatedSubscription();

  useOnSurfaceDeletedSubscription({
    onData: ({ client }) => {
      client.refetchQueries({
        include: [SurfacesDocument],
      });
    },
  });

  return useSurfacesImpl(options);
};
